import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdatePaymentMethodByPkMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  name: Types.Scalars['String']['input'];
  type: Types.Scalars['String']['input'];
  gatewayToken: Types.Scalars['String']['input'];
  gateway: Types.Scalars['String']['input'];
  accountType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  accountNumber: Types.Scalars['bigint']['input'];
  cardType?: Types.InputMaybe<Types.Scalars['String']['input']>;
  expiration?: Types.InputMaybe<Types.Scalars['smallint']['input']>;
  routingNumber?: Types.InputMaybe<Types.Scalars['bigint']['input']>;
  source?: Types.InputMaybe<Types.Scalars['String']['input']>;
  bankName?: Types.InputMaybe<Types.Scalars['String']['input']>;
  accountHolderType?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdatePaymentMethodByPkMutation = { __typename?: 'mutation_root', update_arpaymentmethods_by_pk?: { __typename?: 'arpaymentmethods', id: number, customer_id: number } | null };


export const UpdatePaymentMethodByPkDocument = gql`
    mutation updatePaymentMethodByPk($id: bigint!, $name: String!, $type: String!, $gatewayToken: String!, $gateway: String!, $accountType: String, $accountNumber: bigint!, $cardType: String, $expiration: smallint, $routingNumber: bigint, $source: String, $bankName: String, $accountHolderType: String) {
  update_arpaymentmethods_by_pk(
    pk_columns: {id: $id}
    _set: {name: $name, type: $type, gateway_token: $gatewayToken, gateway: $gateway, account_type: $accountType, account_number: $accountNumber, card_type: $cardType, expiration: $expiration, routing_number: $routingNumber, source: $source, bank_name: $bankName, account_holder_type: $accountHolderType}
  ) {
    id
    customer_id
  }
}
    `;
export type UpdatePaymentMethodByPkMutationFn = Apollo.MutationFunction<UpdatePaymentMethodByPkMutation, UpdatePaymentMethodByPkMutationVariables>;

/**
 * __useUpdatePaymentMethodByPkMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentMethodByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentMethodByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentMethodByPkMutation, { data, loading, error }] = useUpdatePaymentMethodByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      gatewayToken: // value for 'gatewayToken'
 *      gateway: // value for 'gateway'
 *      accountType: // value for 'accountType'
 *      accountNumber: // value for 'accountNumber'
 *      cardType: // value for 'cardType'
 *      expiration: // value for 'expiration'
 *      routingNumber: // value for 'routingNumber'
 *      source: // value for 'source'
 *      bankName: // value for 'bankName'
 *      accountHolderType: // value for 'accountHolderType'
 *   },
 * });
 */
export function useUpdatePaymentMethodByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentMethodByPkMutation, UpdatePaymentMethodByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentMethodByPkMutation, UpdatePaymentMethodByPkMutationVariables>(UpdatePaymentMethodByPkDocument, options);
      }
export type UpdatePaymentMethodByPkMutationHookResult = ReturnType<typeof useUpdatePaymentMethodByPkMutation>;
export type UpdatePaymentMethodByPkMutationResult = Apollo.MutationResult<UpdatePaymentMethodByPkMutation>;
export type UpdatePaymentMethodByPkMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentMethodByPkMutation, UpdatePaymentMethodByPkMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/billing/queries/updatePaymentMethod.mutation.gql}
 */
export async function updatePaymentMethodByPk(
  variables: UpdatePaymentMethodByPkMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdatePaymentMethodByPkMutation['update_arpaymentmethods_by_pk']>
export async function updatePaymentMethodByPk(
  variables: UpdatePaymentMethodByPkMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdatePaymentMethodByPkMutation>
export async function updatePaymentMethodByPk(
  variables: UpdatePaymentMethodByPkMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdatePaymentMethodByPkMutation['update_arpaymentmethods_by_pk'] | UpdatePaymentMethodByPkMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdatePaymentMethodByPkMutation>(
    UpdatePaymentMethodByPkDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_arpaymentmethods_by_pk
}